import { useFormValidation } from 'framework/form';
import { getBytesFromMb, getFileExtension } from '../../utils';
import { getHumanReadableDataSize } from 'framework/utils';

const useArtifactValidationService = ({
  source,
  previewsCount = 0,
  fileTypes,
  maxMb,
}: {
  source?: string;
  previewsCount?: number;
  fileTypes?: string;
  maxMb?: number;
}) => {
  const { getMaxElements } = useFormValidation(source && source);

  const validate = (files: File[]) => {
    let error = null;
    const maxElements = getMaxElements() || 15;
    if (files.length > maxElements - (previewsCount && previewsCount)) {
      error = `Maximum number of files is ${maxElements}`;
    }

    [].forEach.call(files, (file: File) => {
      const fileExtension: any = getFileExtension(file.name);

      if (fileTypes) {
        const allowedFileTypes = fileTypes.split(',');
        if (!allowedFileTypes.includes(fileExtension)) {
          error = 'Invalid file extension';
        }
      }

      if (maxMb && file.size > getBytesFromMb(maxMb)) {
        error = `File size exceeds ${getHumanReadableDataSize(getBytesFromMb(maxMb))}`;
      }
    });

    return error;
  };

  return {
    validate,
  };
};

export default useArtifactValidationService;
